<template>
  <Modal
    :modal-style="{ maxWidth: '900px' }"
    :title="modalTitle"
  >
    <SocialRolesPermissionsTable v-if="isSocial" />
    <RolesPermissionsTable
      v-else
      :product="product"
      :roles="filteredRoles"
    />
  </Modal>
</template>

<script>
import { storeToRefs } from "pinia";

import Modal from "shared/components/core/modals/Modal.vue";
import { capitalize } from "shared/helpers/string";

import RolesPermissionsTable from "src/components/RolesPermissionsTable.vue";
import SocialRolesPermissionsTable from "src/components/SocialRolesPermissionsTable.vue";
import { useGlobalAdminStore } from "src/stores/global";

export default {
  name: "RolesPermissionsModal",
  components: {
    Modal,
    SocialRolesPermissionsTable,
    RolesPermissionsTable,
  },
  props: {
    product: {
      type: String,
      default: "traditional",
    },
  },
  setup() {
    const globalAdminStore = useGlobalAdminStore();
    const { permissions, roles } = storeToRefs(globalAdminStore);

    return { permissions, roles };
  },
  computed: {
    modalTitle() {
      return `${capitalize(this.product)} Roles`;
    },
    isSocial() {
      return this.product === "social";
    },
    filteredRoles() {
      return this.roles.filter((role) => role.product === this.product);
    },
  },
};
</script>
